import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import withErrorHandler from '../../utils/withErrorHandler';
import StarIcon from './StarIcon';

import { handleFavorite as handleFavoriteAction } from '../../actions/actionsSet/assetService';

const mapDispatchToProps = {
  handleFavorite: handleFavoriteAction,
};

export default
@connect(null, mapDispatchToProps)
@withErrorHandler
class FavoriteStar extends PureComponent {
  static propTypes = {
    symbol: PropTypes.string.isRequired,
    active: PropTypes.bool,
    handleFavorite: PropTypes.func.isRequired,
    style: PropTypes.object,
    handleForceUpdate: PropTypes.func,
  };

  static defaultProps = {
    style: {},
    active: false,
  };

  _favoriteSetter = ev => {
    ev.stopPropagation();
    ev.preventDefault();

    const { symbol, handleFavorite, handleForceUpdate } = this.props;
    handleFavorite(symbol);
    if (handleForceUpdate) handleForceUpdate();
  };

  render() {
    const { style, active } = this.props;

    return <StarIcon active={active} onClick={this._favoriteSetter} style={style} />;
  }
}
